<template>
  <p>Please wait...</p>
</template>
<script>
import { getInstance } from "@/auth/authWrapper";
export default {
  data() {
    return {
      authService: getInstance(),
    };
  },
  methods: {
    async init() {
      await this.$store.dispatch("auth/setAuthUser");

      if (this.$store.getters["auth/IsAdmin"]) {
        this.$router.push("/bulk-upload-csv-v2");
      } else {
        alert("You are not authorized to access this page");
        this.$auth.logout({ returnTo: window.location.origin });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>
